import {faDownload} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';
import {useContext, useState} from 'react';

import {useLocale} from '../../../../provider/locale/locale-hook';
import {MainFilterContext} from '../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../provider/main-filter/main-filter-type';
import {ReviewsExportConstructorModal} from '../reviews-export-constructor/reviews-export-constructor-modal';
import {ExportConstructorEditorStateType} from '../reviews-export-constructor/reviews-export-constructor-types';
import {ReviewsExportTemplateEditorModal} from '../reviews-export-constructor/reviews-export-template-editor-modal';
import {ReviewsStateType} from '../reviews-state/reviews-state-type';

type PropsType = {
    reviewsState: ReviewsStateType;
    hasReviews: boolean;
};

export function RequestReport(props: PropsType): JSX.Element {
    const {reviewsState, hasReviews} = props;

    const {getLocalizedString} = useLocale();
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const [isDownloadReportPopupOpen, setIsDownloadReportPopupOpen] = useState<boolean>(false);
    const [editorState, setEditorState] = useState<ExportConstructorEditorStateType | null>(null);

    function handleOpenDownloadModal() {
        setIsDownloadReportPopupOpen(true);
    }

    function handleCloseDownloadModal() {
        setIsDownloadReportPopupOpen(false);
    }

    return (
        <>
            <Button
                icon={<FontAwesomeIcon icon={faDownload} />}
                onClick={handleOpenDownloadModal}
                title={getLocalizedString('REVIEWS__DOWNLOAD_THE_REPORT')}
            />
            <ReviewsExportConstructorModal
                hasReviews={hasReviews}
                isOpen={isDownloadReportPopupOpen}
                mainFilterKey={mainFilterKey}
                onClose={handleCloseDownloadModal}
                onOpenEditor={setEditorState}
                reviewsState={reviewsState}
            />
            <ReviewsExportTemplateEditorModal
                editorState={editorState}
                isOpen={Boolean(editorState)}
                onClose={() => setEditorState(null)}
                onSaved={() => setEditorState(null)}
            />
        </>
    );
}
